import MoreInfo from "../../../lib/MoreInfo";
import React from "react";
import {useTranslation} from "react-i18next";
import Subscription from "../../../lib/Subscription";

const Filters = ({
                   showFilters,
                   changePrice, changePriceEnter, maxPrice,
                   changeWeight, changeWeightEnter, maxWeight,
                   filterYear, year,
                   filterSex, sex, filterSuspension, setFilterSuspension,
                   filterBrand, handleFilterBrand, filterFrame, setFilterFrame,
                   filterBrake, setFilterBrake, filterWheel, handleFilterWheel,
                   filterChainRings, handleFilterChainRings,
                   filterCasette, handleFilterCasette, filterPosition, setFilterPosition,
                   measure, oldMeasure, availableBrands, traject, hasSubscription
                 }) => {

  const [t,] = useTranslation('result');

  let brands = availableBrands || [];

  const showPaywall = () => {
    Subscription.paywall('bikefinder', traject);
  }

  const year2024 = () => {
    if (hasSubscription) {
      filterYear(2024)
    } else {
      showPaywall()
    }
  }

  const speedFilter = () => {
    if (measure === 'body' || oldMeasure === 'body') {
      return (
        <div className="filter">
          {t('Fietshouding')} <i className="fas fa-info-circle moreInfo" onClick={() => {
          MoreInfo.show('filter', 'speed')
        }}></i> <i className="fas fa-caret-down"></i>
          <div className={filterPosition !== '' ? 'active filter-options' : 'filter-options'}>
            <ul>
              <li className={filterPosition === 1 ? 'active' : ''}><span
                onClick={() => setFilterPosition(1)}>{t('Competitief')}</span></li>
              <li className={filterPosition === 2 ? 'active' : ''}><span
                onClick={() => setFilterPosition(2)}>{t('Sportief')}</span></li>
              <li className={filterPosition === 3 ? 'active' : ''}><span
                onClick={() => setFilterPosition(3)}>{t('Recreatief')}</span></li>
            </ul>
          </div>
        </div>
      );
    }
  };

  let year2024Class = year === 2024 ? 'active' : ''
  if (!hasSubscription) {
    year2024Class += 'no-subscription'
  }

  return (
    <div className={"col-sm-3 filters results " + (showFilters ? "mobile-shown" : "mobile-hidden")}>
      <h3>{t('Keuze aanscherpen')}</h3>
      <div className="filter">
        <div className="input-filter">
          <div className="filterLabel">{t('Maximale prijs')}:</div>
          <div className="input-group mb-3">
            <input className="form-control" type="number" name="price" defaultValue={maxPrice}
                   min="0" max="10000" step="100" onBlur={changePrice}
                   onKeyPress={changePriceEnter}/>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2">&euro;</span>
            </div>
          </div>
        </div>


        <div className="input-filter">
          <div className="filterLabel">{t('Maximaal gewicht')}:</div>
          <div className="input-group mb-3">
            <input className="form-control" type="number" name="weight"
                   defaultValue={maxWeight ? maxWeight : ''}
                   onBlur={changeWeight} onKeyPress={changeWeightEnter}/>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2">Kg</span>
            </div>
          </div>
        </div>
      </div>

      <div className="filter">
        {t('Year')} <i className="fas fa-caret-down"></i>
        <div className={year === '' ? 'filter-options' : 'active filter-options'}>
          <ul>
            <li className={year2024Class}><span
              onClick={year2024}>2024</span></li>
            <li className={year === 2023 ? 'active' : ''}><span
              onClick={() => filterYear(2023)}>2023</span></li>
            <li className={year === 2022 ? 'active' : ''}><span
              onClick={() => filterYear(2022)}>2022</span></li>
            <li className={year === 2021 ? 'active' : ''}><span
              onClick={() => filterYear(2021)}>2021</span></li>
            <li className={year === 2020 ? 'active' : ''}><span
              onClick={() => filterYear(2020)}>2020</span></li>
            <li className={year === 2019 ? 'active' : ''}><span
              onClick={() => filterYear(2019)}>2019</span></li>
          </ul>
        </div>
      </div>

      {speedFilter()}

      <div className="filter">
        {t('Frametype')}<i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'frametype')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={sex !== '' ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={sex === 1 ? 'active' : ''}><span
              onClick={() => filterSex(1)}>{t('Man')}</span></li>
            <li className={sex === 2 ? 'active' : ''}><span
              onClick={() => filterSex(2)}>{t('Vrouw')}</span></li>
            <li className={sex === 3 ? 'active' : ''}><span
              onClick={() => filterSex(3)}>{t('Unisex')}</span></li>
          </ul>
        </div>
      </div>

      {traject === 'mtb' &&
      <div className="filter">
        {t('Vering')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'suspension')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterSuspension !== '' ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterSuspension === 1 ? 'active' : ''}><span
              onClick={() => setFilterSuspension(1)}>{t('Rigid')}</span></li>
            <li className={filterSuspension === 2 ? 'active' : ''}><span
              onClick={() => setFilterSuspension(2)}>{t('Hardtail')}</span></li>
            <li className={filterSuspension === 3 ? 'active' : ''}><span
              onClick={() => setFilterSuspension(3)}>{t('Fully')}</span></li>
          </ul>
        </div>
      </div>
      }

      <div className="filter">
        {t('Merk')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'brand')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterBrand.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            {brands !== undefined && brands.length > 0 ?
              brands.map((brand, i) => {
                return (
                  <li key={i}
                      className={filterBrand.indexOf(brand) !== -1 ? 'active' : ''}><span
                    onClick={handleFilterBrand}>{brand}</span></li>
                )
              }) : <li><span>{t('No Brands')}</span></li>

            }
          </ul>
        </div>
      </div>

      <div className="filter">
        {t('MTBSummary_FrameMaterial')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'material')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterFrame.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterFrame.indexOf('Aluminum') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterFrame('Aluminum')}>{t('Aluminum')}</span></li>
            <li className={filterFrame.indexOf('Carbon') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterFrame('Carbon')}>{t('Carbon')}</span></li>
            <li className={filterFrame.indexOf('Staal') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterFrame('Staal')}>{t('Staal')}</span></li>
            <li className={filterFrame.indexOf('Titanium') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterFrame('Titanium')}>{t('Titanium')}</span></li>
          </ul>
        </div>
      </div>

      {traject === 'race' &&
      <div className="filter">
        {t('Remsysteem')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'brake_type')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterBrake.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterBrake.indexOf('Disc') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterBrake('Disc')}>{t('Schijfrem')}</span></li>
            <li className={filterBrake.indexOf('Rim') !== -1 ? 'active' : ''}><span
              onClick={() => setFilterBrake('Rim')}>{t('Velgrem')}</span></li>
          </ul>
        </div>
      </div>
      }

      {traject === 'mtb' &&
      <div className="filter">
        {t('Wielmaat')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'wheelsize')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterWheel.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterWheel.indexOf('29"') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('29"')}</span></li>
            <li className={filterWheel.indexOf('27,5"') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('27,5"')}</span></li>
            <li className={filterWheel.indexOf('26"') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('26"')}</span></li>
            <li className={filterWheel.indexOf('27,5+') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('27,5+')}</span></li>
            <li className={filterWheel.indexOf('26" Fat') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('26" Fat')}</span></li>
            <li className={filterWheel.indexOf('27,5"/29"') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('27,5"/29"')}</span></li>
            <li className={filterWheel.indexOf('27,5+/29"') !== -1 ? 'active' : ''}><span
              onClick={handleFilterWheel}>{t('27,5+/29"')}</span></li>
          </ul>
        </div>
      </div>
      }
      <div className="filter">
        {t('Voorbladen')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'chainrings')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterChainRings.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterChainRings.indexOf('Single') !== -1 ? 'active' : ''}><span
              onClick={handleFilterChainRings}>{t('Single')}</span></li>
            <li className={filterChainRings.indexOf('Double') !== -1 ? 'active' : ''}><span
              onClick={handleFilterChainRings}>{t('Double')}</span></li>
            <li className={filterChainRings.indexOf('Triple') !== -1 ? 'active' : ''}><span
              onClick={handleFilterChainRings}>{t('Triple')}</span></li>
          </ul>
        </div>
      </div>

      <div className="filter">
        {t('Cassette')} <i className="fas fa-info-circle moreInfo" onClick={() => {
        MoreInfo.show('filter', 'casette')
      }}></i> <i className="fas fa-caret-down"></i>
        <div className={filterCasette.length > 0 ? 'active filter-options' : 'filter-options'}>
          <ul>
            <li className={filterCasette.indexOf('1-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('1-speed')}</span></li>
            <li className={filterCasette.indexOf('7-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('7-speed')}</span></li>
            <li className={filterCasette.indexOf('8-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('8-speed')}</span></li>
            <li className={filterCasette.indexOf('9-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('9-speed')}</span></li>
            <li className={filterCasette.indexOf('10-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('10-speed')}</span></li>
            <li className={filterCasette.indexOf('11-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('11-speed')}</span></li>
            <li className={filterCasette.indexOf('12-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('12-speed')}</span></li>
            <li className={filterCasette.indexOf('13-speed') !== -1 ? 'active' : ''}><span
              onClick={handleFilterCasette}>{t('13-speed')}</span></li>
          </ul>
        </div>
      </div>

      {!hasSubscription && (
        <div className="filter-cta-buttons mt-4 text-center">
          <button className="btn btn-primary" onClick={showPaywall}>{t('Result_Subscribe')}</button>
        </div>
      )}
    </div>
  )
};

export default Filters;
